export const styledInput = (direction,hasError = false) => ({
    disableUnderline: true,
    className: `custom-box-sizing-border-box ${direction}`,
    sx: {
        height: '48px',
        padding: '0 10px',
        borderRadius: '8px',
        background: '#F5F5F6',
        border: hasError ? '2px solid #d32f2f' : '1px solid transparent',
        '&:focus-within': {
            border: `2px solid ${hasError ? '#d32f2f' : '#304FFF'}`,
        },
    },
});